import axios from "axios";
import {
  getLocalAccessToken,
  getLocalRefreshToken,
  getRefreshToken,
} from "./getTokens";

export const axiosApiInstance = axios.create();

axiosApiInstance.interceptors.request.use(
  (config) => {
    const token = getLocalAccessToken();
    const refreshToken = getLocalRefreshToken();

    const extractedPath = config?.url?.split("api/")[1];

    if (extractedPath === "UserLogin/CheckRefreshToken") {
      if (refreshToken) {
        config.headers["Authorization"] = "Bearer " + refreshToken;
      }
    } else {
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
    }

    return Promise.resolve(config);
  },
  (error) => {
    return Promise.reject(error);
  },
);

let isSessionExpired = false;

axiosApiInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;
    const FBTOKEN = localStorage.getItem("FBTOKEN");
    const FBUserID = localStorage.getItem("FBUserID");

    const handleSessionExpired = () => {
      if (isSessionExpired) return;
      isSessionExpired = true;

      localStorage.clear();
      if (FBTOKEN !== null) {
        localStorage.setItem("FBTOKEN", FBTOKEN);
      }
      if (FBUserID !== null) {
        localStorage.setItem("FBUserID", FBUserID);
      }

      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    };

    if (err.response) {
      if (err.response.status === 419 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await getRefreshToken();
          const token = rs?.data?.Data?.Token;

          if (!token) {
            throw new Error("No token received");
          }

          localStorage.setItem("Token", token);
          axiosApiInstance.defaults.headers.common["Authorization"] =
            "Bearer " + token;

          return axiosApiInstance(originalConfig);
        } catch (error) {
          handleSessionExpired();
          return Promise.reject("Session expired - please login again");
        }
      }

      if (err.response.status === 420) {
        handleSessionExpired();
        return Promise.reject("Session expired");
      }

      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }

    if (!err.response) {
      if (originalConfig.url.includes("CheckRefreshToken")) {
        handleSessionExpired();
        return Promise.reject(
          "Session maintenance failed - please login again",
        );
      }

      return Promise.reject({
        message: err.message || "Network error",
        code: err.code || "NETWORK_ERROR",
      });
    }

    return Promise.reject(err);
  },
);
